/**
=========================================================
* SuitOrbit - Rutas de Facturación
=========================================================

  Conjunto de rutas dedicado al módulo de Facturación.
  Sigue el mismo esquema que `routes.js`:

  1. `type: "collapse"`  → entrada de menú navegable.
  2. `type: "title"`     → título dentro del Sidenav.
  3. `type: "divider"`   → divisor visual.
  4. `name`              → texto visible en el Sidenav.
  5. `key`               → identificador único (también usado
                            por `tienePermisosModulo`).
  6. `icon`              → icono mostrado en el Sidenav.
  7. `collapse`          → array con sub-rutas (menú anidado).
  8. `route`             → path de react-router para la entrada.
  9. `component`         → componente que se renderiza en la ruta.

  Para añadir un nuevo módulo de facturación basta con
  agregar una entrada al array `routesFac`.
*/

// Layouts
import Dashboard from "layouts/dashboard";
import Entrar from "layouts/login";

// Pantallas de Facturación
import RegistroClientes from "modules/clientessuplidores/RegistroClientes";
import MantenimientoProductos from "productosnoserializados/MantenimientoProductos";
import FacturaPOS from "facturapos/FacturaPOS";
import FacturaCredito from "facturascredito/FacturaCredito";
import MantenimientoFacturasEmitidas from "facturapos/MantenimientoFacturasEmitidas";
import ListadoNotasCreditoDebitoEmitidas from "facturapos/ListadoNotasCreditoDebitoEmitidas";
import ConfiguracionDocumentosFiscales from "facturapos/reglasventas";
import RegistroCotizaciones from "cotizaciones/RegistroCotizaciones";
import CuentasPorCobrar from "facturascredito/CuentasPorCobrar";
import RegistroPagosClientesCredito from "facturascredito/RegistroPagosClientesCredito";
import PagosClienteCreditoDetallePage from "facturascredito/PagosClienteCreditoDetalle";
import ConfiguracionFactura from "facturapos/ConfiguracionFactura";
import CuadreCajaPage from "facturapos/CuadreCaja";
import GestionFormasDePago from "configuracion/GestionFormasDePago";
import UsuariosRoles from "modules/configuracion/usuariosroles";
import RegistroCompra from "compras/RegistroCompra";
import RecepcionCompra from "compras/RecepcionCompra";
import OrdenDePedido from "cotizaciones/OrdenDePedido";
import RegistroConduce from "conduce/RegistroConduce";
import TrazabilidadConduce from "conduce/TrazabilidadConduce";

// Iconos
import Icon from "@mui/material/Icon";

const routesFac = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Clientes Suplidores",
    key: "clientessuplidores",
    programa: "clientessuplidores",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/clientesuplidores/registroclientessuplidores",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Clientes / Suplidores",
        key: "registroclientessuplidores",
        route: "/clientesuplidores/registroclientessuplidores",
        component: <RegistroClientes />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Productos",
    key: "mantenimientoproductos",
    programa: "mantenimientoproductos",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/facturacion/mantenimientoproductos",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Productos",
        key: "mantenimientoproductos",
        route: "/facturacion/mantenimientoproductos",
        component: <MantenimientoProductos />,
      },
    ],
  },
  
  {
    type: "collapse",
    name: "Ventas",
    key: "ventas",
    programa: "mantenimientoventas",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/facturacion/ventasfacturacion",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Ventas POS",
        key: "facturapos",
        route: "/facturacion/facturapos",
        component: <FacturaPOS />,
      },
      {
        type: "collapse",
        name: "Ventas Credito",
        key: "facturacredito",
        route: "/facturacion/facturacredito",
        component: <FacturaCredito />,
      },
      {
        type: "collapse",
        name: "Facturas Emitidas",
        key: "mantenimientofacturasemitidas",
        route: "/facturacion/facturasemitidas",
        component: <MantenimientoFacturasEmitidas />,
      },

      {
        type: "collapse",
        name: "Cuadre de Caja",
        key: "cuadrecajapos",
        route: "/facturacion/cuadrecajapos",
        component: <CuadreCajaPage />,
      },
      
      {
        type: "collapse",
        name: "NC/ND Emitidas",
        key: "notacreditodebitoemitidas",
        route: "/facturacion/notasdebitocreditoemitidas",
        component: <ListadoNotasCreditoDebitoEmitidas />,
      },

      {
        type: "collapse",
        name: "Reglas de Ventas",
        key: "regladeventas",
        route: "/facturacion/reglasdeventas",
        component: <ConfiguracionDocumentosFiscales />,
      },

      {
        type: "collapse",
        name: "Cotizaciones",
        key: "registrocotizaciones",
        route: "/facturacion/registrocotizaciones",
        component: <RegistroCotizaciones />,
      },

      {
        type: "collapse",
        name: "Órdenes de Pedido",
        key: "ordenesdepedido",
        programa: "ordenesdepedido",
        route: "/facturacion/ordenesdepedido",
        component: <OrdenDePedido />,
      },

      {
        type: "collapse",
        name: "Registro de Conduce",
        key: "registrarconduces",
        programa: "registrarconduces",
        route: "/facturacion/registroconduce",
        component: <RegistroConduce />,
      },

      {
        type: "collapse",
        name: "Trazabilidad Conduces",
        key: "trazabilidadconduces",
        programa: "trazabilidadconduces",
        route: "/facturacion/trazabilidadconduces",
        component: <TrazabilidadConduce />,
      },

      {
        type: "collapse",
        name: "Configuracion Facturas",
        key: "configuracionfacturas",
        route: "/facturacion/configuracionfacturas",
        component: <ConfiguracionFactura />,
      },
      
    ],
      
  },
  
  {
    type: "collapse",
    name: "Compras",
    key: "compras",
    programa: "mantenimientocompras",
    aliases: ["compras", "mantenimientocompras", "registrocompras", "recepcioncompras"],
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/facturacion/registrocompras",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Registro de Compras",
        key: "registrocompras",
        aliases: ["compras", "mantenimientocompras", "registrocompras"],
        route: "/facturacion/registrocompras",
        component: <RegistroCompra />,
      },
      {
        type: "collapse",
        name: "Recepción de Compras",
        key: "recepcioncompras",
        aliases: ["compras", "mantenimientocompras", "recepcioncompras"],
        route: "/facturacion/recepcioncompras",
        component: <RecepcionCompra />,
      },
    ],
  },

  
  {
    type: "collapse",
    name: "Cuentas x Cobrar",
    key: "cuentasxcobrar",
    programa: "cuentasxcobrar",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/facturacion/cuentasxcobrar",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Cuentas x Cobrar",
        key: "cuentasxcobrar",
        route: "/facturacion/cuentasxcobrar",
        component: <CuentasPorCobrar />,
      },

      {
        type: "collapse",
        name: "Detalle de Pagos de Clientes Credito",
        key: "pagosclientescreditodetalledialog",
        route: "/facturacion/pagosclientescreditodetalledialog",
        component: <PagosClienteCreditoDetallePage />,
      },
      
      
      {
        type: "collapse",
        name: "Registro de Pagos de Clientes Credito",
        key: "registropagosclientescredito",
        route: "/facturacion/registropagosclientescredito",
        component: <RegistroPagosClientesCredito />,
      },

      

      
      
    ],
      
  },

  {
    type: "collapse",
    name: "Confifiguracion General",
    key: "configuraciongeneral",
    programa: "configuraciongeneral",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/facturacion/configuraciongeneral",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Formas de Pago",
        key: "configuracionformaspago",
        route: "/facturacion/configuracionformaspago",
        component: <GestionFormasDePago />,
      },

      // Misma pantalla que el hub de Configuración de préstamos: se gobierna
      // con el programa "configuracion" (los endpoints config_* ya lo exigen
      // en el server), así que solo la ven los roles administradores.
      {
        type: "collapse",
        name: "Usuarios y Roles",
        key: "configuracion",
        route: "/facturacion/usuariosroles",
        component: <UsuariosRoles />,
      },

    ],
      
  },

  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/login",
    component: <Entrar />,
  },
  {
    name: "Sign Up",
    key: "sign-up",
    route: "/login",
    component: <Entrar />,
  },
];

export default routesFac;
